document.addEventListener('alpine:init', () => {
  Alpine.data('wistiaPlaylist', () => ({
    playing: '',

    init() {
      this.playing = this.$root.dataset.playing;
    },

    play(id, width, height) {
      this.playing = id;
      this.$refs.main.style.aspectRatio = width / height;
      this.$refs.main.innerHTML = `<script src="https://fast.wistia.com/embed/${id}.js" async type="module"></script>
      <style>wistia-player[media-id='${id}']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/${id}/swatch'); display: block; filter: blur(5px); padding-top: ${
        (height / width) * 100
      }%; }</style>
      <wistia-player media-id="${id}" aspect="${width / height}" autoplay="true"></wistia-player>`;
    },
  }));
});